import { render, staticRenderFns } from "./repsol-filter-chips.component.html?vue&type=template&id=00ef2ea8&external"
import script from "./RepsolFilterChipsComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolFilterChipsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports